import React, { FC, useEffect, useState } from 'react'
import { Country } from 'api/countries/getCountriesList'
import styles from './SearchableCountryList.module.scss'
import { ColorType, SearchField } from 'components/Searchfield/SearchField'
import { t, Trans } from '@lingui/macro'
import { SearchableCountryListItem } from './SearchableCountryListItem/SearchableCountryListItem'
import { useSearchableCountrylist } from './useSearchableCountrylist'

interface Props {
  countryList: Country[]
  selectedAlpha2: string
  onCountrySelect: (country: Country) => void
}

export const SearchableCountrylist: FC<Props> = ({
  countryList,
  selectedAlpha2,
  onCountrySelect
}) => {
  const { searchText, setSearchText, filteredCountryList } =
    useSearchableCountrylist(countryList)

  return (
    <div className={styles.Container}>
      <SearchField
        type={ColorType.Light}
        onSearch={(searchText: string) => setSearchText(searchText)}
        onClearSearchText={() => setSearchText('')}
        showBackArrow={false}
        placeholder={t`Search`}
        onBackArrowClick={() => null}
      />
      <div className={styles.List}>
        {filteredCountryList.length > 0 ? (
          filteredCountryList?.map((country: Country) => {
            const isSelected = country.alpha2 === selectedAlpha2
            return (
              <SearchableCountryListItem
                key={country.alpha2}
                country={country}
                isSelected={isSelected}
                onCountrySelect={onCountrySelect}
              />
            )
          })
        ) : (
          <div className={styles.Item}>
            <Trans>No results for {searchText}</Trans>
          </div>
        )}
      </div>
    </div>
  )
}
